import React from 'react';
import { Link } from 'react-router-dom';

// Minimal markdown renderer for CMS content (news articles, FAQ answers).
// Supports: ## / ### headings, paragraphs, "- " lists, **bold** and [text](url).

const INLINE_PATTERN = /(\*\*[^*]+\*\*|\[[^\]]+\]\([^)]+\))/g;

export const renderInline = (text, keyPrefix = 'i') => {
    const parts = text.split(INLINE_PATTERN).filter(Boolean);

    return parts.map((part, index) => {
        const key = `${keyPrefix}-${index}`;

        if (part.startsWith('**') && part.endsWith('**')) {
            return <strong key={key}>{part.slice(2, -2)}</strong>;
        }

        const link = part.match(/^\[([^\]]+)\]\(([^)]+)\)$/);
        if (link) {
            const [, label, href] = link;
            if (href.startsWith('/')) {
                return <Link key={key} to={href}>{label}</Link>;
            }
            return (
                <a key={key} href={href} target="_blank" rel="noopener noreferrer">
                    {label}
                </a>
            );
        }

        return <React.Fragment key={key}>{part}</React.Fragment>;
    });
};

const Markdown = ({ text = '' }) => {
    const blocks = text.replace(/\r\n/g, '\n').trim().split(/\n{2,}/);

    return (
        <>
            {blocks.map((block, index) => {
                const key = `b-${index}`;
                const lines = block.split('\n');

                if (block.startsWith('### ')) {
                    return <h3 key={key}>{renderInline(block.slice(4), key)}</h3>;
                }
                if (block.startsWith('## ')) {
                    return <h2 key={key}>{renderInline(block.slice(3), key)}</h2>;
                }
                if (lines.every((line) => line.startsWith('- '))) {
                    return (
                        <ul key={key}>
                            {lines.map((line, i) => (
                                <li key={`${key}-${i}`}>{renderInline(line.slice(2), `${key}-${i}`)}</li>
                            ))}
                        </ul>
                    );
                }
                return <p key={key}>{renderInline(lines.join(' '), key)}</p>;
            })}
        </>
    );
};

export default Markdown;
